export const TYPES = {
  SET_DEFAULT_PAPER_ALL: "default_paper/SET_DEFAULT_PAPER_ALL",
  SET_DEFAULT_PAPER_OPEN_ADD: "default_paper/SET_DEFAULT_PAPER_OPEN_ADD",
  SET_DEFAULT_PAPER_OPEN_EDIT: "default_paper/SET_DEFAULT_PAPER_OPEN_EDIT",
  SET_DEFAULT_PAPER_SELECTED: "default_paper/SET_DEFAULT_PAPER_SELECTED",
  SET_DEFAULT_PAPER_SEARCH: "default_paper/SET_DEFAULT_PAPER_SEARCH",
  //
  SET_DEFAULT_PAPER_LAST: "default_paper/SET_DEFAULT_PAPER_LAST",
};
